export default "__VITE_ASSET__DQzgfwXI__"